import { builder } from '@builder.io/sdk';
import { Hero } from 'react-scale/components/pages/homepage/hero/with-3d-shape';
import Events, { Event } from 'react-scale/components/pages/homepage/events';
import WhyScale from 'react-scale/components/pages/homepage/why-scale';
import ApplyAI from 'react-scale/components/pages/homepage/apply-ai';
import Resources, { Resource } from 'react-scale/components/pages/homepage/resources';
import BuildAI from 'react-scale/components/pages/homepage/build-ai';
import QuotesSection from 'react-scale/components/pages/homepage/quotes';
import { CTASimpleCentered, Footer } from 'react-scale/components';
import ImgBgBase64 from 'react-scale/components/pages/homepage/bg-img';

import { GetStaticProps } from 'next';

import {
  HorizontalLine,
  VerticalLine,
  VerticalLineContainer
} from 'react-scale/components/pages/homepage/dashed-line';
import { fetchAnnouncementBanner } from 'react-scale/lib/announcement-banner-fetch';
import { useState } from 'react';

const Homepage = ({ page, announcementBannerData, guides }) => {
  return (
    <div className="relative overflow-x-hidden">
      {/* <ImgBgBase64
        onLoadingComplete={() => {
          setHeroImageLoaded(true);
        }}
        imageLoaded={heroImageLoaded}
      /> */}

      <VerticalLineContainer
      // style={{ opacity: heroImageLoaded ? 1 : 0 }}
      // className="transition-opacity duration-100"
      >
        <VerticalLine />
        <VerticalLine inverted />
      </VerticalLineContainer>

      <Hero announcementBannerData={announcementBannerData} />
      <Events events={page.events as { event: Event }[]} />
      <HorizontalLine />
      <WhyScale />
      <HorizontalLine />
      <BuildAI />
      <HorizontalLine />
      <ApplyAI />
      <HorizontalLine />
      <Resources resources={page.resources as { resource: Resource }[]} />
      <HorizontalLine />
      <QuotesSection quotes={page.quotes.quotes} />
      <HorizontalLine />
      <CTASimpleCentered
        title="The future of your industry starts here!"
        themeColors={{ textColor: 'text-white' }}
        cta={{
          buttons: [
            {
              text: 'Book a Demo',
              type: 'primary',
              href: '/demo',
              variant: 'default'
            },
            {
              text: 'Build AI',
              href: '/data-engine',
              type: 'secondary'
            }
          ]
        }}
      />
      <HorizontalLine />
      <Footer theme="dark" border={false} guides={guides} />
    </div>
  );
};

Homepage.theme = 'dark';

export default Homepage;

export const getStaticProps: GetStaticProps = async () => {
  const [homepage, announcementBannerData, guides] = await Promise.all([
    builder.get('homepage-content', { options: { includeUnpublished: true } }).promise(),
    fetchAnnouncementBanner('/'),
    builder.getAll('guides-lp', {
      options: { noTargeting: true },
      omit: 'data.blocks',
      limit: 9
    })
  ]);

  return {
    props: {
      page: homepage.data,
      announcementBannerData: announcementBannerData ?? null,
      guides: guides.map(guide => ({ name: guide.name, slug: guide.data.url }))
    },
    revalidate: 1
  };
};
